export enum Protocol {
  ID = 0,
  SECP256K1 = 1,
  ACTOR = 2,
  BLS = 3
}
